import { css } from 'aphrodite';
import * as React from 'react';
import { CheckIcon } from './icons/CheckIcon';
import { ExclamationIcon } from './icons/ExclamationIcon';
import { XIcon } from './icons/XIcon';
import { styleSheet } from './styles';

export type CheckInResultType = 'success' | 'error' | 'warning';

interface IProps {
	type: CheckInResultType;
	title: string;
	message: string;
	subtitle?: string;
	guestCount?: string;
}

export const CheckInResult: React.FC<IProps> = ({ type, title, message, subtitle, guestCount }) => {
	const renderIcon = () => {
		switch (type) {
			case 'success':
				return <CheckIcon className={css(styleSheet.icon, styleSheet.iconSuccess)} />;
			case 'error':
				return <XIcon className={css(styleSheet.icon, styleSheet.iconError)} />;
			case 'warning':
				return <ExclamationIcon className={css(styleSheet.icon, styleSheet.iconWarning)} />;
			default:
				return <CheckIcon className={css(styleSheet.icon, styleSheet.iconSuccess)} />;
		}
	};

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.iconContainer)}>{renderIcon()}</div>

			<h3
				className={css(
					styleSheet.title,
					styleSheet[`title${type.charAt(0).toUpperCase() + type.slice(1)}` as keyof typeof styleSheet]
				)}
			>
				{title}
			</h3>

			<p className={css(styleSheet.message)}>{message}</p>

			{subtitle && <p className={css(styleSheet.subtitle)}>{subtitle}</p>}

			{guestCount && <p className={css(styleSheet.guestCount)}>{guestCount}</p>}
		</div>
	);
};
